module.exports = __webpack_public_path__ + "img/thumbnail_AfricanWildDog_j_normal.bd57ebfc.png";